import { NgModule } from '@angular/core';
import { ButtonComponent } from '@app/infrastructure/buttons/button/button.component';
import { ButtonOutlineComponent } from '@app/infrastructure/buttons/button-outline/button-outline.component';
import { ButtonReloadComponent } from './button-reload/button-reload.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { ExportCvsButtonComponent } from './export-cvs-button/export-cvs-button.component';

@NgModule({
	declarations: [
		ButtonOutlineComponent,
		ButtonComponent,
		ButtonReloadComponent,
		ButtonIconComponent,
		ExportCvsButtonComponent,
	],
	exports: [
		ButtonOutlineComponent,
		ButtonComponent,
		ButtonReloadComponent,
		ButtonIconComponent,
		ExportCvsButtonComponent,
	],
	imports: [TooltipModule],
})
export class ButtonsModule {}
